import type { SVGProps } from 'react';

export const SvgGuideNavIconDevice = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={73} height={72} viewBox="0 0 73 72" fill="none" {...props}>
    <circle cx={36.5} cy={36} r={35} fill="#FF001A" stroke="#FF001A" strokeWidth={2} transform="rotate(-180 36.5 36)" />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M36 43H26a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h10M36 47h-6M50 25H40a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V26a1 1 0 0 0-1-1M33 43v4"
    />
    <path fill="#fff" d="M45 40.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
  </svg>
);
